import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=463fa16f&"
import script from "./LogsTable.vue?vue&type=script&lang=js&"
export * from "./LogsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463fa16f')) {
      api.createRecord('463fa16f', component.options)
    } else {
      api.reload('463fa16f', component.options)
    }
    module.hot.accept("./LogsTable.vue?vue&type=template&id=463fa16f&", function () {
      api.rerender('463fa16f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/logs/LogsTable.vue"
export default component.exports